import {User, UserIdentifier, Owner} from './user/userModel';
import {Topic} from "./topicModel";
import * as environment from '../../environments/environment';
const be_url = environment.environment.backend_proto + "://" + environment.environment.backend_host + ":" + environment.environment.backend_port + environment.environment.backend_path;

 export class BoardSocialMediaProfil {
     user_name: string = "user_Test_Name";
     channelTitle: string = "user_Test_Name";
     user_screen_name: string = "user_Test_display_Name";
     user_profile_image: string = "default_user_level_message";
     user_id: number =-1;
     user_followers_count: number = -1;
     api_channel: string = "twitter";
     api_icon: string = "assets/images/sm_icon/twitter.png";
     api_provider_id: number = 2;


     constructor(user_name?:string, channelTitle?: string, user_screen_name?:string, user_profile_image?:string, user_id?:number, user_followers_count?: number, api_channel?:string, api_icon?:string, api_provider_id?:number){
         this.user_name = user_name;
         this.channelTitle = channelTitle;
         this.user_screen_name = user_screen_name;
         this.user_profile_image = user_profile_image;
         this.user_id = user_id;
         this.user_followers_count = user_followers_count;
         this.api_channel = api_channel;
         this.api_icon = api_icon;
         this.api_provider_id = api_provider_id;

     }
 }
 export class TwitterUserProfileUser{
     target: string = "";
     other: BoardSocialMediaProfil[] = [];
     verified: BoardSocialMediaProfil[] = [];
 }


 export class SocialMediaTwitterUserProfileQueryResponse {
     userProfiles: TwitterUserProfileUser[] = [];
 }

 export class BoardLink {
     displayName: string;
     name: string;
     id: number;
     constructor(displayName?:string, name?:string, id?: number){
         this.displayName = displayName;
         this.name = name;
         this.id = id;
     }

 }

export class Board {
    board_id: BoardIdentifier = new BoardIdentifier(-1);
    board_name: string = "default_board_name";
    board_description: string = "default_board_description";
    board_follower: number;
    board_hits: number;
    session_user_follows:boolean;
    owner_id: number = -1;
    topic_id:number=-1;
    board_imprint;
    board_ceo: string;
    amazon_url: string;
    apple_url: string;
    android_url: string;
    amazon_music_url:string;
    apple_music_url:string;
    google_music_url:string;
    deezer_music_url:string;
    board_avatar_vibrant: string;
    board_screenname:string;
    merchandise_url:string;
    user_like_state: boolean;
    board_homepage: string;
    board_avatar: string = be_url + "/images/default/dummy.png";
    board_owner: Owner = new Owner(new User(-1, "default_user_name", be_url + "/images/default/dummy.png"),[new BoardIdentifier(0)]);
    board_topics: Topic[] = [];
    static board: any;

    constructor(board_id?:number, board_name?: string, board_description?:string, board_follower?:number, board_hits?:number, session_user_follows?:boolean, owner_id?:number, topic_id?:number, board_avatar?: string, board_owner?: Owner, board_topics?: Topic[], board_avatar_vibrant?: string, board_screenname?:string){
        this.board_id = new BoardIdentifier(board_id);
        this.board_name = board_name;
        this.board_description = board_description;
        this.board_follower = board_follower;
        this.board_hits = board_hits;
        this.session_user_follows = session_user_follows;
        this.owner_id = owner_id;
        this.topic_id = topic_id;
        this.board_avatar = board_avatar;
        this.board_owner = board_owner;
        if(board_topics != null){
            this.board_topics = board_topics;
        }
        this.board_avatar_vibrant = board_avatar_vibrant;
        this.board_screenname = board_screenname;
    }
    public getBoardsWithSelectedTopics(){
        let relevantBoards = this.board_topics.map(board_topic => {
            if(board_topic.isSelected() == true){
                return this;
            }
            return null;
        });
    }
}

export class BoardIdentifier {
    board_id: number = -1;
    constructor(newBoardId?){
        this.board_id=newBoardId;
    }
}

export class SearchBoardBackendResponse {
    count: number = -1;
    response: SearchBoard[] = [];
}

export class SearchBoard {
    name: string = "default_search_board.name";
    image: string = "default_search_board.image";
}

export class UserRelatedBoard extends Board {

    relations: UserToBoardRelation[] = [];
    constructor(board_id?:number, board_name?: string, board_description?:string, board_follower?:number, board_hits?:number, session_user_follows?:boolean, owner_id?:number, topic_id?:number,board_avatar?: string, board_avatar_vibrant?:string, board_screenname?:string, board_owner?: Owner,board_topics?: Topic[],UserToBoardRelations?:UserToBoardRelation[]){
        super(board_id, board_name, board_description, board_follower,  board_hits, session_user_follows, owner_id, topic_id,  board_avatar, board_owner, board_topics, board_avatar_vibrant, board_screenname);
        if(UserToBoardRelations!=null){
            this.relations = UserToBoardRelations;
        }
    }
    public getRelationsAsString():string{
        let str="";
        this.relations.map((relation, index, arr) => {
            str += relation.relation.toString();
            if(index <=arr.length-1){
                str += ", ";
            }
        });
        return str;
    }
    public matchesAllRelations(relations_to_match: UserToBoardRelation[]):boolean{
        let matchesCount = 0;
        this.relations.map(relation => {
            relations_to_match.map(match_relation=> {
                if(relation.relation == match_relation.relation){
                    matchesCount++;
                }
            })
        });

        if((matchesCount > 0) && (relations_to_match.length == this.relations.length)){
            return true;
        }
        return false;
    }
    public getFollowRelation(){
        return true
    }
}

export class UserRelatedBoards {
    count:number = -1;
    userRelatedBoards: UserRelatedBoard[] = [];
}


export class UserToBoardRelation {
    relation: string = "default_user_to_board_relation";
    constructor(boardRelation?:string){
        this.relation = boardRelation;
    }
}

export class UserNotificationsBoard {
    board_id:number;
    board_name: string;
    board_avatar:string;
    user_name: string;
    user_id: number;
    user_avatar: string;
    board_follower_count:number;

}

export class Media{
    media_url: string;
    media_url_https: string;
}

export class FeedForUserWhereBoardsAreFollowing
{
    board_avatar: string;
    board_id: number;
    board_name: string;
    board_topic_id: number;
    created: Date;
    like_count: number;
    local_user_liked: boolean;
    post_id: number;
    post_image: string;
    post_text: string;
    sortTime: number;
    timeAgo: string;


    constructor(board_avatar?:string, board_id?: number, board_name?:string, board_topic_id?:number, created?:Date,  like_count?: number, local_user_liked?: boolean, post_id?: number, post_image?: string, post_text?: string, sortTime?:number, timeAgo?:string){
        this.board_avatar = board_avatar;
        this.board_id = board_id;
        this.board_name = board_name;
        this.board_topic_id = board_topic_id;
        this.created = created;
        this.like_count = like_count;
        this.local_user_liked = local_user_liked;
        this.post_id = post_id;
        this.post_image = post_image;
        this.post_text = post_text;
        this.sortTime = sortTime;
        this.timeAgo = timeAgo
    }
}


export class BoardSocialMediaContent
{
    id: number;
    channel: string;
    channelIcon: string;
    screenname: string;
    images: string;
    text: string;
    video: boolean;
    url: string;
    likes: number;
    reshare: boolean;
    date: any;
    like_count: string ;
    dislike_count: string;
    view_count: string;
    sortTime: number;
    isDisplayed: boolean;
    channelTitel:string;
    urlToOriginal: string;
    play_count: string;
    links: string;
    comment_count: string;
    share_count: string;

    constructor(id?:number, channel?: string, channelIcon?:string, screenname?:string, images?:string,  text?: string, video?: boolean, url?: string, likes?: number, reshare?: boolean, date?:any, like_count?:string, dislike_count?:string, view_count?:string, sortTime?:number, isDisplayed?:boolean, channelTitel?:string, urlToOriginal?:string,play_count?:string,links?:string, comment_count?:string, share_count?:string ){
        this.id = id;
        this.channel = channel;
        this.channelIcon = channelIcon;
        this.screenname = screenname;
        this.images = images;
        this.text = text;
        this.video = video;
        this.url = url;
        this.likes = likes;
        this.reshare = reshare;
        this.date = date;
        this.like_count = like_count;
        this.dislike_count = dislike_count;
        this.view_count = view_count;
        this.sortTime = sortTime;
        this.isDisplayed = isDisplayed;
        this.channelTitel = channelTitel;
        this.urlToOriginal = urlToOriginal;
        this.play_count = play_count;
        this.links = links;
        this.comment_count = comment_count;
        this.share_count = share_count;

    }
}
export class SocialMediaPostForBoard extends BoardSocialMediaContent {
    // topic_id: number = -1; // todo what about topic_id s related to boards?
    relations: UserToBoardRelation[] = [];
    constructor(id?:number, channel?: string, channelIcon?:string, screenname?:string, images?:string, text?: string, video?:boolean, url?:string, likes?:number, reshare?:boolean, date?:any, like_count?:string, dislike_count?:string, view_count?:string, sortTime?: number, isDisplayed?:boolean, channelTitel?:string, urlToOriginal?:string,play_count?:string,links?:string, comment_count?:string, share_count?:string){
        super(id, channel, channelIcon, screenname, images, text, video, url, likes, reshare, date, like_count, dislike_count, view_count, sortTime, isDisplayed, channelTitel, urlToOriginal, play_count,links, comment_count, share_count );
    }
}

export class SocialMediaContentGoogle
{
    quelle: string;
    keyword: string;
    images: string;
    text: string;
    urlToOriginal: string;
    links: string;
    sortTime: number;
    video: boolean;
    url: string;


    constructor(quelle?: string, keyword?:string, images?:string,  text?: string, urlToOriginal?:string,links?:string, sortTime?:number, video?:boolean, url?: string ){
        this.quelle = quelle;
        this.keyword = keyword;
        this.images = images;
        this.text = text;
        this.urlToOriginal = urlToOriginal;
        this.links = links;
        this.sortTime = sortTime;
        this.video = video;
        this.url = url;

    }
}

export class FollowerFromBoard {
    user_id: number = -1;
    user_name: string = "sido";
    user_avatar: string ="assets/images/sido.jpg"
    user_city: string ="berlin"
    user_is_verified: number;

    constructor(user_id?:number, user_name?:string, user_avatar?:string, user_city?:string, user_is_verified?:number ){
        this.user_id = user_id
        this.user_name = user_name;
        this.user_avatar = user_avatar;
        this.user_city = user_city;
        this.user_is_verified = user_is_verified;
    }
}
export class FollowerOFBoards extends FollowerFromBoard {
    constructor(user_id?:number, user_name?:string, user_avatar?:string, user_city?:string, user_is_verified?:number){
        super(user_id, user_name, user_avatar, user_city, user_is_verified);
    }
}

/**
 * social_media_provider_id: number;
 social_media_account: string;
 social_media_account_id: string;
 social_media_account_meta: string;
 */
export class SocialMediaRelation {
    social_media_provider_id: number;
    social_media_account: string;
    social_media_account_id: string;
    social_media_account_meta: string;

    constructor(social_media_provider_id: number, social_media_account: string, social_media_account_id: string, social_media_account_meta: string){
        this.social_media_provider_id=social_media_provider_id;
        this.social_media_account=social_media_account;
        this.social_media_account_id=social_media_account_id;
        this.social_media_account_meta=social_media_account_meta;
    }
}

export class CreateNewBoard {
    image_type: string; // e.g. 'image/jpg'
    image: string = null; // e.g. <backend_host_via_settings> + "/images/board_images/sido.jpg"
    image_external: string; // set to "true" if you want to save a url reference to an third party hosted image (or false see postman for examples)
    name: string;
    description: string;
    board_homepage: string;
    amazon_url: string;
    apple_url: string;
    android_url: string;
    merchandise_url: string;
    amazon_music_url: string;
    apple_music_url: string;
    google_music_url: string;
    deezer_music_url: string;
    board_screenname: string;
    topic_id: number; // e.g. 1 for topic with id 1, etc
    social_media_relations: SocialMediaRelation[] = [];
    constructor(image_type, image, image_external, name, description, board_homepage, amazon_url, apple_url, android_url, merchandise_url, amazon_music_url, apple_music_url, google_music_url, deezer_music_url,  board_screenname, topic_id, social_media_relations?){
        this.image_type =image_type;
        this.image =image;
        this.image_external =image_external;
        this.name =name;
        this.description =description;
        this.board_homepage = board_homepage;
        this.amazon_url = amazon_url;
        this.apple_url = apple_url;
        this.android_url = android_url;
        this.merchandise_url = merchandise_url;
        this.amazon_music_url = amazon_music_url;
        this.apple_music_url = apple_music_url;
        this.google_music_url = google_music_url;
        this.deezer_music_url = deezer_music_url;
        this.board_screenname = board_screenname;
        this.topic_id =topic_id;
        if(social_media_relations != null){
            this.social_media_relations=social_media_relations;
        }
    }

}

export class backendApiInputCreateNewBoardWrapper{
    board: CreateNewBoard;
    constructor(createNewBoard:CreateNewBoard){
        this.board = createNewBoard;

    }
}

export class BoardComment{
    board_id: number;
    comment:{
        comment_id: number;
        created_at: string;
        likedBy:{}
        likes: number;
        message: string;
        modified_at: Date;
        owner:{
            user_avatar: "assets/images/sido.jpg"
            user_id: -1;
            user_name: "name"
        }
    }
    comment_id: number;
    user_id: number;
    user_like_state: boolean;
    user_like_state2: number =1;
}

export class EditExistingBoard {
    image_type: string;
    image: string = null; // e.g. "http://localhost:8080/images/board_images/sido.jpg"
    image_external: boolean; // set to "true" if you want to save a url reference to an third party hosted image (or false see postman for examples)
    name: string; // please for give us : ), we knew it was bad naming : ) -> this refers to the image name
    board_name: string;
    board_description: string;
    board_imprint: string;
    board_homepage: string;
    amazon_url: string;
    apple_url: string;
    android_url: string;
    merchandise_url: string;
    amazon_music_url: string;
    apple_music_url: string;
    google_music_url: string;
    deezer_music_url: string;
    board_avatar_vibrant:string;
    board_screenname:string;
    topics_id: number; // e.g. 1 for topic with id 1, etc
    social_media_relations: SocialMediaRelationModification = new SocialMediaRelationModification();
    mandatory_image_input: boolean = false;

    constructor(image_type:string, image:string, image_external:boolean, name:string, mandatory_image_input:boolean, board_name:string, board_description:string, board_imprint:string, topics_id:number, social_media_relations?:SocialMediaRelationModification, board_homepage?:string, amazon_url?:string, apple_url?:string, android_url?:string, merchandise_url?:string, amazon_music_url?:string, apple_music_url?:string, google_music_url?:string, deezer_music_url?:string, board_avatar_vibrant?:string, board_screenname?:string) {
        this.image_type = image_type;
        this.image = image;
        this.image_external = image_external;
        this.name = name;
        this.board_name = board_name;
        this.board_description = board_description;
        this.board_imprint = board_imprint;
        this.topics_id = topics_id;
        this.board_homepage = board_homepage;
        this.amazon_url = amazon_url;
        this.apple_url = apple_url;
        this.android_url = android_url;
        this.merchandise_url = merchandise_url;
        this.amazon_music_url = amazon_music_url;
        this.apple_music_url = apple_music_url;
        this.google_music_url = google_music_url;
        this.deezer_music_url = deezer_music_url;
        this.board_avatar_vibrant = board_avatar_vibrant;
        this.board_screenname = board_screenname;
        this.mandatory_image_input = mandatory_image_input;
        if (social_media_relations != null) {
            this.social_media_relations = social_media_relations;
        }
    }
}

export class SocialMediaRelationsToDelete {
    social_media_provider_id: number;
    social_media_account_id: string;

    constructor(social_media_provider_id: number, social_media_account_id: string) {
        this.social_media_provider_id = social_media_provider_id;
        this.social_media_account_id = social_media_account_id;
    }
}

export class SocialMediaRelationsToAdd {
    social_media_provider_id: number;
    social_media_account: string;
    social_media_account_id: string;
    social_media_account_meta: string;
    associated_profile_image: string;

    constructor(social_media_provider_id: number, social_media_account: string, social_media_account_id: string, social_media_account_meta: string, associated_profile_image: string) {
        this.social_media_provider_id = social_media_provider_id;
        this.social_media_account = social_media_account;
        this.social_media_account_id = social_media_account_id;
        this.social_media_account_meta = social_media_account_meta;
        this.associated_profile_image = associated_profile_image;
    }
}

export class SocialMediaRelationModification {
    relationsToAdd: SocialMediaRelationsToAdd[] = [];
    relationsToDelete: SocialMediaRelationsToDelete[] = [];
    constructor(relationsToAdd?:SocialMediaRelationsToAdd[], relationsToDelete?:SocialMediaRelationsToDelete[]){
        if(relationsToAdd != null){
            this.relationsToAdd = relationsToAdd;
        }
        if(relationsToDelete != null){
            this.relationsToDelete = relationsToDelete;
        }

    }
}
